import { TUpdateDocumentTemplateParams } from '@commenda/types/src/document-generation';
import { fetcher } from '@commenda/utils';
import { BASE_URL } from './helpers';

export const updateDocumentTemplate = async (
  documentTemplateId: string,
  data: TUpdateDocumentTemplateParams
): Promise<Response> => {
  const res = await fetcher(`${BASE_URL}/${documentTemplateId}`, {
    method: 'POST',
    body: data,
  });
  return res;
};
